import React, { useState, useEffect, useContext, useRef } from "react";
// import EditIcon from '@material-ui/icons/Edit';
// "@mui/material/LaunchIcon";
import { useNavigate, useParams } from "react-router-dom";
import LaunchIcon from "@mui/icons-material/Launch";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import IconButton from "@mui/icons-material/Icon";
// import CloseIcon from "@material-ui/icons/Close";
// import IconButton from "@material-ui/core/IconButton";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { OverlayPanel } from "primereact/overlaypanel";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
// import SearchIcon from "@material-ui/icons/Search";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button as MuiButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Toolbar } from "@mui/material";
import { Container, Stack } from "@mui/system";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CustomerContext from "../../context/customer/CustomerContext";
import "./ClientProfiles.scss";
import Dialog from "@mui/material/Dialog";
import CustomDialog from "../common/CustomDialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import _ from "lodash";
import AuthContext from "../../context/auth/AuthContext";
import axios from "axios";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { tokens } from "../../theme/tokens";
import { styled } from "@mui/material/styles";
import { TrackNowButton } from "../ui/TrackNowButton";
import { useCommonDetailsContext } from "../../context/Common/common";
import SvgIcon from "@mui/material/SvgIcon";

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

function ClientLookup(props) {
  const { publishedBranding, clientScopedBranding, setClientScopedBranding, validateParentData, fetchClientBranding } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const OrganizationArrow = () => (
    <SvgIcon
      sx={{
        fontSize: 20,
        color: "#483568",
      }}
      viewBox="0 -960 960 960"
    >
      <path d="M480-80 200-360l56-57 184 184v-287h80v287l184-183 56 56L480-80Zm-40-520v-120h80v120h-80Zm0-200v-80h80v80h-80Z" />
    </SvgIcon>
  );
  const op = useRef(null);
  const customerContext = useContext(CustomerContext);
  const { customers, selectedCustomer, setCurrentCustomer, getCustomers } = customerContext;
  //const [isPopUpVisible, setIsPopUpVisible] = useState(false);
  const { clientId } = useParams();
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [client, setClient] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerListRef, setCustomerListRef] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [selectedCustomerObj, setSelectCustomerObj] = useState(false);
  const [changedCustomer, setChangedCustomer] = useState(null);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const authContext = useContext(AuthContext);
  const { roleType, authUser } = authContext;
  const theme = useTheme();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [remainingCategories, setRemainingCategories] = useState([]);
  const [remainingPrograms, setRemainingPrograms] = useState([]);
  const [isStatePopupOpen, setStatePopupOpen] = useState(false);
  const [remainingStateCategories, setRemainingStateCategories] = useState([]);

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isDeferredSelectionPage =
    props.parentRoute === "add-filings" ||
    props.parentRoute === "add-filing-postaward" ||
    props.parentRoute === "client-filing-tracker-list";
  const isInitialClientSelection = !clientId;
  const dialogTitle = isInitialClientSelection ? "Select Client" : "Change Client";
  const clientBannerLabel =
    !clientId
      ? ""
      : client && client.customerName
        ? client.customerName
        : "Please select a valid client";

  const navigate = useNavigate();
  function handleNavigatebefore() {
    // if (isDeferredSelectionPage && clientId) {
    //   navigate(`/${props.parentRoute}`);
    //   return;
    // }
    navigate("/");
  }

  const customerSelected = (val) => {
    console.log("customerSelected", "val", val);

    setSelectCustomerObj(val);
    setSelectCustomer(val.customerName);
  };
  function handleEditClick() {
    setSearchTerm("");
    getCustomerList();
    setOpen(true);
  }

  function handleClose() {
    setCustomerList(customerListRef);
    setSearchTerm("")
    getCustomerList();
    setSelectCustomerObj("");
    setOpen(false);
  }
  function handleCancelClose() {
    setCustomerList(customerListRef);
    setSelectCustomerObj("");
    setSearchTerm("")
    getCustomerList();
    setOpen(false);
  }

  function handleBannerClick() {
    setIsBannerVisible(!isBannerVisible);
  }

  function handleCloseClick1() {
    setIsBannerVisible(false);
  }

  const syncClientSelection = (customer) => {
    if (!customer) {
      return;
    }

    setClient(customer);
    setSelectCustomerObj(customer);

    if (
      setCurrentCustomer &&
      String(selectedCustomer?.customerId) !== String(customer.customerId)
    ) {
      setCurrentCustomer(customer);
    }

    if (!validateParentData?.isSingleParent && customer.customerId && fetchClientBranding) {
      const matched = (customerListRef && customerListRef.length > 0 ? customerListRef : customerList)?.find(
        (c) => String(c.customerId) === String(customer.customerId)
      );
      const customerType = customer.customerType || customer.clientType || matched?.customerType || matched?.clientType;
      fetchClientBranding(customer.customerId, customerType);
    }
  };

  // useEffect(() => {
  // fetch("")
  // .then((custListponse) => custListponse.json())
  // .then((data) => setItems(data));
  // }, []);
  useEffect(() => {
    getCustomerList();
  }, [authUser, customers]);

  useEffect(() => {
    if (clientId) {
      const hasMatchingSelectedCustomer =
        selectedCustomer &&
        String(selectedCustomer.customerId) === String(clientId);

      if (hasMatchingSelectedCustomer) {
        syncClientSelection(selectedCustomer);
      } else {
        let isSelectedCustomer = localStorage.getItem("selectedCustomer") !== null
          ? JSON.parse(localStorage.getItem("selectedCustomer"))
          : null;

        if (
          isSelectedCustomer &&
          String(isSelectedCustomer.customerId) === String(clientId)
        ) {
          syncClientSelection(isSelectedCustomer);
        }
      }
    } else {
      setClient(null);
      setSelectCustomerObj(null);
      if (setClientScopedBranding) {
        setClientScopedBranding(null);
      }
    }
  }, [clientId]);

  useEffect(() => {
    if (!clientId || !customerListRef || customerListRef.length === 0) {
      return;
    }

    const hasAccess = customerListRef.some(
      (cust) => String(cust.customerId) === String(clientId)
    );

    if (!hasAccess) {
      console.log(`Access check failed for clientId ${clientId}, redirecting...`);
      setCurrentCustomer(null);
      localStorage.removeItem("selectedCustomer");
      setClient(null);
      setSelectCustomerObj(null);
      navigate(`/${props.parentRoute}`);
      setOpen(true);
      return;
    }

    const matchedCustomer = customerListRef.find(
      (cust) => String(cust.customerId) === String(clientId)
    );

    if (matchedCustomer) {
      syncClientSelection(matchedCustomer);
    }
  }, [clientId, customerListRef]);

  useEffect(() => {
    if (!isDeferredSelectionPage || !isInitialClientSelection) {
      return;
    }

    setOpen(true);
  }, [isDeferredSelectionPage, isInitialClientSelection]);



  const getCustomerList = async () => {
    try {
      // let custList = await axios.get(`${API_BASE_URL}/Customer/CustomerList`);
      let custList;
      if (customers) {
        custList = customers;
      } else {
        custList = await getCustomers();
      }
      let _data;
      // if (
      //   !(roleType.includes("Admin") || roleType.includes("Admin-PostAward"))
      // ) {
      //   _data = custList.filter((ele) =>
      //     authUser.clients.includes(ele.customerId)
      //   );
      // } else {
      //   _data = custList;
      // }
      _data = custList;
      if (props.parentRoute === "add-filings") {
        _data = _data.filter(
          (ele) => (ele.trackNowLicenseId && Number(ele.trackNowLicenseId) > 0)
        );
        setCustomerList(_data);
        setCustomerListRef(_data);
      } else if (props.parentRoute === "add-filing-postaward") {

        _data = _data.filter(
          (ele) => (ele.postAwardLicenseId && Number(ele.postAwardLicenseId) > 0)
        );
        setCustomerList(_data);
        setCustomerListRef(_data);
      } else {
        setCustomerList(_data);
        setCustomerListRef(_data);
      }


    } catch (error) {
      console.log(error);
    }
  };

  function handleSearchChange(event) {
    // setSearchTerm(event.target.value);
    setSearchTerm(event.target.value);
    let customerArr = customerListRef;
    if (event.target.value != "") {
      let searchedArr = customerArr.filter((customer) => {
        return customer.customerName
          .toLowerCase()
          .includes(event.target.value.toLowerCase());
      });
      setCustomerList(searchedArr);
    } else if (event.target.value == "") {
      getCustomerList();
    }
  }

  function handleSearchClick() {
    // const filtered = items.filter(
    // (item) => item.name.includes(searchTerm) || item.id === searchTerm
    // );
    // setFilteredItems(filtered);
  }

  function getCustomer(customerId) {
    if (customers) {
      const _custRecs = customers.filter(
        (cust) => cust.customerId == customerId
      );
      return _custRecs[0];
    } else return null;
  }
  const handleBreadcrumbClick = async (node) => {
    const res = await axios.get(`${API_BASE_URL}/Customer/CustomerList`, {
      params: {
        customerId: node.customerId,
      },
    });
    const fullCustomerDetails = res.data[0];
    // Update local selection states
    setSelectCustomerObj(fullCustomerDetails);
    setSelectCustomer(node.customerName);
    setChangedCustomer(node.customerName);

    // Update parent/context states
    props.setSelectedClientId(node.customerId);
    setCurrentCustomer(fullCustomerDetails);
    setClient(fullCustomerDetails);

    if (!validateParentData?.isSingleParent && fetchClientBranding) {
      const matched = (customerListRef && customerListRef.length > 0 ? customerListRef : customerList)?.find(
        (c) => String(c.customerId) === String(node.customerId)
      );
      const customerType = fullCustomerDetails?.customerType || fullCustomerDetails?.clientType || node?.customerType || node?.clientType || matched?.customerType || matched?.clientType;
      fetchClientBranding(node.customerId, customerType);
    }

    // Close modal and reset searches
    setOpen(false);
    setSearchTerm("");
    getCustomerList();
    setCustomerList(customerListRef);

    // Navigate to the new client
    navigate(`/${props.parentRoute}/${node.customerId}`, {
      state: {
        clientName: node.customerName,
      },
    });
  };
  const handleChange = (event) => {

    setChangedCustomer(selectCustomer);
    // const {
    // target: { value },
    // } = event;
    // const _client = getCustomer(selectedCustomerObj.customerId);
    // console.log("$$VAL_clientId:", selectedCustomerObj.customerId);
    props.setSelectedClientId(selectedCustomerObj.customerId);
    setCurrentCustomer(selectedCustomerObj);
    setClient((cust) => selectedCustomerObj);

    if (!validateParentData?.isSingleParent && fetchClientBranding && selectedCustomerObj?.customerId) {
      const matched = (customerListRef && customerListRef.length > 0 ? customerListRef : customerList)?.find(
        (c) => String(c.customerId) === String(selectedCustomerObj.customerId)
      );
      const customerType = selectedCustomerObj?.customerType || selectedCustomerObj?.clientType || matched?.customerType || matched?.clientType;
      fetchClientBranding(selectedCustomerObj.customerId, customerType);
    }

    setOpen(false);
    setSearchTerm("");
    getCustomerList();
    setCustomerList(customerListRef);
    navigate(`/${props.parentRoute}/${selectedCustomerObj.customerId}`, {
      state: {
        clientName: selectedCustomerObj.customerName,
      },
    });
  };

  function MouseOver(event) {
    event.target.style.background = "#BDBDBD";
  }
  function MouseOut(event) {
    event.target.style.background = "";
  }

  const isItemSelected = (value) => {

    return selectedCustomerObj?.customerId === value;
  };
  const getBusinessCategories = (categories) => {
    // Safeguard: If categories is undefined, null, or not an array, return empty arrays
    if (!Array.isArray(categories)) {
      return { displayedCategories: [], remainingCategories: [] };
    }

    const _federalCat = categories.filter((item) => !item.state);

    const displayedCategories = _federalCat.map(
      (item) => item.businessCategoryName
    );

    const remainingCategories = _federalCat
      .slice(2)
      .map((item) => item.businessCategoryName);

    return { displayedCategories, remainingCategories };
  };
  const handleDisplayOrganizationalStructure = () => {
    if (props && props.showStructure) {
      props.showStructure();
    }
  }
  const renderOrganizationStructureExpander = (clientData) => {
    const org = clientData?.organizationalStructure;

    if (!org) return "-";

    const roots = Array.isArray(org) ? org : [org];

    // Recursive helper to get all paths from a node down to its leaves
    const getAllPaths = (node, currentPath = []) => {
      const newPath = [...currentPath, node];

      // If the node has no children, we've reached the end of a path
      if (!node.children || node.children.length === 0) {
        return [newPath];
      }

      // If there are children, recursively get paths for ALL children
      let paths = [];
      for (const child of node.children) {
        paths = paths.concat(getAllPaths(child, newPath));
      }
      return paths;
    };

    // Generate all distinct routes for the root(s)
    let allPaths = [];
    roots.forEach((root) => {
      allPaths = allPaths.concat(getAllPaths(root));
    });

    // Extract ONLY the first path to render
    const firstPath = allPaths.length > 0 ? allPaths[0] : [];
    const elements = [];

    firstPath.forEach((node, nodeIndex) => {
      // ✅ Moved isCurrentClient inside the loop so it has access to 'node'
      const isCurrentClient = String(node.customerId) === String(clientId);

      elements.push(
        <Tooltip
          key={`node-0-${node.customerId}`}
          title={node.customerName}
          arrow
          placement="top"
        >
          <Typography
            component="span"
            onClick={(e) => {
              e.stopPropagation();
              // Only trigger the change if it's not the currently active client
              if (!isCurrentClient) {
                handleBreadcrumbClick(node);
              }
            }}
            sx={{
              // Gray out the text if it is the current client
              color: isCurrentClient ? "text.secondary" : "#432568",
              cursor: isCurrentClient ? "default" : "pointer",
              fontSize: "14px",
              fontWeight: isCurrentClient ? 600 : 400, // Bold the active client to make it clear
              transition: "color 0.2s ease",
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: 0,
              flexShrink: 1,
              maxWidth: "100%",
              "&:hover": {
                textDecoration: "none",
                fontWeight: isCurrentClient ? 600 : "bold",
                color: isCurrentClient ? "text.secondary" : "#2a1542",
              },
            }}
          >
            {node.customerName}
          </Typography>
        </Tooltip>
      );

      // Add the ">" separator if it's not the last node in this specific path
      if (nodeIndex < firstPath.length - 1) {
        elements.push(
          <Typography
            key={`sep-0-${node.customerId}`}
            component="span"
            sx={{
              mx: 0.5,
              color: "text.secondary",
              fontSize: "14px",
              flexShrink: 0,
            }}
          >
            {" > "}
          </Typography>
        );
      }
    });

    // If there is more than 1 route in total, display the "View Structure" link with the count
    const showViewStructure = allPaths.length > 1;
    const remainingCount = allPaths.length - 1;

    return (
      <Stack spacing={0.5} sx={{ width: "100%", overflow: "hidden" }}>
        {/* Render ONLY the first path */}
        {elements.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              overflow: "hidden",
              flexWrap: "nowrap",
            }}
          >
            {elements}
          </Box>
        )}

        {showViewStructure && (
          <Typography
            variant="caption"
            color="primary"
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              width: "fit-content",
              "&:hover": {
                textDecoration: "none",
                fontWeight: "bold",
              },
            }}
            onClick={handleDisplayOrganizationalStructure}
          >
            View Structure (+{remainingCount} more)
          </Typography>
        )}
      </Stack>
    );
  };
  const getProgramName = (programOptions) => {
    if (!Array.isArray(programOptions)) {
      return { displayPrograms: [], remainingPrograms: [] };
    }

    const _programList = programOptions.filter((item) => !item?.state);
    const displayPrograms = _programList.map((item) => item.programName);

    const remainingPrograms = _programList
      .slice(2)
      .map((item) => item.programName);


    return { displayPrograms, remainingPrograms };

  };
  const getStateBusinessCategories = (categories) => {
    if (!Array.isArray(categories)) {
      return { displayedStateCategories: [], remainingStateCategories: [] };
    }
    const _stateCat = categories.filter((item) => item.state !== null);
    // const updStateCategories = _stateCat.map(
    //   (item) => `${ item.state } - ${ item.businessCategoryName }`
    // );

    //return updStateCategories;
    const displayedStateCategories = _stateCat
      //.slice(0, 2)
      .map((item) => `${item.state} - ${item.businessCategoryName}`);

    const remainingStateCategories = _stateCat
      .slice(2)
      .map((item) => `${item.state} - ${item.businessCategoryName}`);

    return { displayedStateCategories, remainingStateCategories };
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
    setRemainingCategories([]);
  };
  const handleStatePopupClose = () => {
    setStatePopupOpen(false);
    setRemainingStateCategories([]);
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));
  const overlayRef = useRef(null);
  const overlayProgramNameRef = useRef(null);
  const overlayStateRef = useRef(null);
  const overlayLookupRefs = {
    federal: overlayRef,
    program: overlayProgramNameRef,
    state: overlayStateRef,
  };

  const hideOtherLookupOverlays = (currentKey) => {
    Object.entries(overlayLookupRefs).forEach(([key, ref]) => {
      if (key !== currentKey && ref.current?.hide) {
        ref.current.hide();
      }
    });
  };

  const toggleLookupOverlay = (event, key) => {
    event.preventDefault();
    event.stopPropagation();

    const overlayRefByKey = overlayLookupRefs[key];
    const overlayPanel = overlayRefByKey?.current;
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherLookupOverlays(key);
    }

    overlayPanel.toggle(event);
  };

  console.log("clientBannerLabel", clientBannerLabel);

  return (
    <Container style={{ margin: "0 1rem", padding: "0 " }}>
      <Grid
        style={{
          width: "100%",
        }}
      >
        <Toolbar
          style={{
            maxWidth: "100%",
            padding: "0",
            marginTop: "1rem",
            backgroundColor: tokens.colors.offWhite,
            borderRadius: "8px",
            border: `0.5px solid ${tokens.colors.connectedPurple}`,
            zIndex: 11,
          }}
        >
          <div
            style={{
              display: isBannerVisible ? "none" : "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "1rem",
            }}
          >
            <div style={{ display: "flex" }}>
              <NavigateBeforeIcon
                style={{ color: "#757575", cursor: "pointer" }}
                onClick={handleNavigatebefore}
              />
              <div style={{ mr: "2rem" }}>
                {clientBannerLabel}
              </div>

              <LaunchIcon
                onClick={handleEditClick}
                style={{
                  fontSize: "1.3em",
                  cursor: "pointer",
                  color: "#757575",
                }}
              />
            </div>
            {isBannerVisible ? null : (
              <TrackNowButton
                variant="primary"
                onClick={handleBannerClick}
                disabled={!selectedCustomerObj && !client?.customerName}
              >
                View Details
              </TrackNowButton>
            )}
          </div>

          {isBannerVisible && (
            <Paper
              style={{
                backgroundColor: tokens.colors.offWhite,
                width: "100%",
                paddingTop: "1rem",
              }}
            >
              <Toolbar style={{ minHeight: "40px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <NavigateBeforeIcon
                      style={{ color: "#757575", cursor: "pointer" }}
                    />

                    {clientBannerLabel ? (
                      <div style={{ marginLeft: "10px" }}>
                        {clientBannerLabel}
                      </div>
                    ) : (
                      ""
                    )}
                    <LaunchIcon
                      onClick={handleEditClick}
                      style={{
                        fontSize: "1.3em",
                        color: "#757575",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <CloseIcon
                      onClick={handleCloseClick1}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </Toolbar>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TableContainer style={{ paddingLeft: "2vw" }}>
                    <TableHead>
                      <TableCell
                        style={{
                          color: "#9E9E9E",
                          height: "5vw",
                          width: "5vw",
                        }}
                      >
                        ID b
                      </TableCell>
                      <TableCell
                        style={{
                          color: "#9E9E9E",
                          height: "5vw",
                          width: "12vw",
                        }}
                      >
                        Client Name
                      </TableCell>
                      {props.parentRoute === "client-filing-tracker-list" && (
                        <TableCell
                          style={{
                            color: "#9E9E9E",
                            width: "450px",
                            minWidth: "250px",
                            maxWidth: "450px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Organizational Structure
                        </TableCell>
                      )}
                      <TableCell
                        style={{
                          color: "#9E9E9E",
                          height: "5vw",
                          width: "10vw",
                        }}
                      >
                        Federal Business Category
                      </TableCell>
                      <TableCell
                        style={{
                          color: "#9E9E9E",
                          height: "5vw",
                          width: "10vw",
                        }}
                      >
                        Program Name
                      </TableCell>
                      <TableCell
                        style={{
                          color: "#9E9E9E",
                          height: "5vw",
                          width: "20vw",
                        }}
                      >
                        State Business Category
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      <TableCell
                        style={{
                          height: "5vw",
                          width: "5vw",
                          verticalAlign: "top",
                        }}
                      >
                        {client?.customerId}
                      </TableCell>
                      <TableCell
                        style={{
                          height: "5vw",
                          width: "10vw",
                          verticalAlign: "top",
                        }}
                      >
                        {client?.customerName &&
                          client?.customerName.length > 25 ? (
                          <Tooltip title={client?.customerName}>
                            <span>{client?.customerName.substr(0, 25)}...</span>
                          </Tooltip>
                        ) : (
                          <span>{client?.customerName}</span>
                        )}
                      </TableCell>
                      {props.parentRoute === "client-filing-tracker-list" && (
                        <TableCell
                          style={{
                            width: "450px",
                            minWidth: "250px",
                            maxWidth: "450px",
                            verticalAlign: "top",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {renderOrganizationStructureExpander(client)}
                        </TableCell>
                      )}
                      <TableCell
                        style={{
                          maxH: "5vw",
                          width: "15vw",
                          verticalAlign: "top",
                        }}
                      >
                        {getBusinessCategories(client?.businessCategory)
                          .displayedCategories.slice(0, 2)
                          .map((category, index) => (
                            <React.Fragment key={index}>
                              {category.length > 25 ? (
                                <Tooltip title={category} key={index}>
                                  <span>{category.substr(0, 25)}...</span>
                                </Tooltip>
                              ) : (
                                <span>
                                  {category}
                                  {index !==
                                    getBusinessCategories(
                                      client?.businessCategory
                                    ).displayedCategories.length -
                                    1 && ","}
                                </span>
                              )}
                              <br />
                            </React.Fragment>
                          ))}
                        {getBusinessCategories(client?.businessCategory)
                          .remainingCategories.length > 0 && (
                            <span
                              className="client-lookup-more"
                              style={{
                                color: "#9ca3af",
                                cursor: "pointer",
                                textDecoration: "none",
                              }}
                              onClick={(event) => {
                                setPopupOpen(true);
                                setRemainingCategories(
                                  getBusinessCategories(client?.businessCategory)
                                    .remainingCategories
                                );
                                toggleLookupOverlay(event, "federal");
                              }}
                            >
                              {`+ ${getBusinessCategories(client?.businessCategory)
                                .remainingCategories.length
                                } more`}
                            </span>
                          )}
                        {/* The OverlayPanel */}
                        <OverlayPanel
                          ref={overlayRef}
                          onHide={() => setPopupOpen(false)}
                          showCloseIcon={true}
                          dismissable
                          className="client-profile-overlay-panel"
                        >
                          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                            Federal Business Categories
                          </Typography>
                          <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
                            <ul style={{ paddingLeft: "20px", margin: 0 }}>
                              {getBusinessCategories(
                                client?.businessCategory
                              ).displayedCategories.map((category, index) => (
                                <li key={index} style={{ marginBottom: "4px" }}>
                                  {category.length > 50 ? (
                                    <Tooltip title={category}>
                                      <span>{`${category.substr(
                                        0,
                                        50
                                      )
                                        }...`}</span>
                                    </Tooltip>
                                  ) : (
                                    <span>{category}</span>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </OverlayPanel>
                      </TableCell>


                      <TableCell
                        style={{
                          maxH: "5vw",
                          width: "15vw",
                          verticalAlign: "top",
                        }}
                      >
                        {getProgramName(client?.programinfo)
                          .displayPrograms.slice(0, 2)
                          .map((program, index) => (
                            <React.Fragment key={index}>
                              {program.length > 25 ? (
                                <Tooltip title={program} key={index}>
                                  <span>{program.substr(0, 25)}...</span>
                                </Tooltip>
                              ) : (
                                <span>
                                  {program}
                                  {index !==
                                    getProgramName(
                                      client?.programinfo
                                    ).displayPrograms.length -
                                    1 && ","}
                                </span>
                              )}
                              <br />
                            </React.Fragment>
                          ))}
                        {getProgramName(client?.programinfo)
                          .remainingPrograms.length > 0 && (
                            <span
                              className="client-lookup-more"
                              style={{
                                color: "#9ca3af",
                                cursor: "pointer",
                                textDecoration: "none",
                              }}
                              onClick={(event) => {
                                setPopupOpen(true);
                                setRemainingPrograms(
                                  getProgramName(client?.programinfo)
                                    .remainingPrograms
                                );
                                toggleLookupOverlay(event, "program");
                              }}
                            >
                              {`+ ${getProgramName(client?.programinfo)
                                .remainingPrograms.length
                                } more`}
                            </span>
                          )}
                        {/* The OverlayPanel */}
                        <OverlayPanel
                          ref={overlayProgramNameRef}
                          onHide={() => setPopupOpen(false)}
                          showCloseIcon={true}
                          dismissable
                          className="client-profile-overlay-panel"
                        >
                          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                            Program Names
                          </Typography>
                          <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
                            <ul style={{ paddingLeft: "20px", margin: 0 }}>
                              {getProgramName(
                                client?.programinfo
                              ).displayPrograms.map((program, index) => (
                                <li key={index} style={{ marginBottom: "4px" }}>
                                  {program.length > 50 ? (
                                    <Tooltip title={program}>
                                      <span>{`${program.substr(
                                        0,
                                        50
                                      )
                                        }...`}</span>
                                    </Tooltip>
                                  ) : (
                                    <span>{program}</span>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </OverlayPanel>
                      </TableCell>

                      <TableCell
                        style={{
                          maxH: "5vw",
                          width: "15vw",
                          verticalAlign: "top",
                        }}
                      >
                        {getStateBusinessCategories(client?.businessCategory)
                          .displayedStateCategories.slice(0, 2)
                          .map((category, index) => (
                            <React.Fragment key={index}>
                              {category.length > 25 ? (
                                <Tooltip title={category} key={index}>
                                  <span>{category.substr(0, 25)}...</span>
                                </Tooltip>
                              ) : (
                                <span>
                                  {category}
                                  {index !==
                                    getStateBusinessCategories(
                                      client?.businessCategory
                                    ).displayedStateCategories.length -
                                    1 && ","}
                                </span>
                              )}
                              <br />
                            </React.Fragment>
                          ))}
                        {getStateBusinessCategories(client?.businessCategory)
                          .remainingStateCategories.length > 0 && (
                            <span
                              className="client-lookup-more"
                              style={{
                                color: "#9ca3af",
                                cursor: "pointer",
                                textDecoration: "none",
                              }}
                              onClick={(event) => {
                                setStatePopupOpen(true);
                                setRemainingStateCategories(
                                  getStateBusinessCategories(
                                    client?.businessCategory
                                  ).remainingStateCategories
                                );
                                toggleLookupOverlay(event, "state");
                              }}
                            >
                              {`+${getStateBusinessCategories(
                                client?.businessCategory
                              ).remainingStateCategories.length
                                } more`}
                            </span>
                          )}
                        {/* The OverlayPanel */}
                        <OverlayPanel
                          ref={overlayStateRef}
                          onHide={() => setStatePopupOpen(false)}
                          showCloseIcon={true}
                          dismissable
                          className="client-profile-overlay-panel"
                        >
                          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                            State Business Categories
                          </Typography>
                          <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
                            <ul style={{ paddingLeft: "20px", margin: 0 }}>
                              {getStateBusinessCategories(
                                client?.businessCategory
                              ).displayedStateCategories.map(
                                (category, index) => (
                                  <li key={index} style={{ marginBottom: "4px" }}>
                                    {category.length > 40 ? (
                                      <Tooltip title={category}>
                                        <span>{`${category.substr(
                                          0,
                                          40
                                        )
                                          }...`}</span>
                                      </Tooltip>
                                    ) : (
                                      <span>{category}</span>
                                    )}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        </OverlayPanel>
                      </TableCell>
                    </TableBody>
                  </TableContainer>
                </Grid>
              </Grid>
            </Paper>
          )}
        </Toolbar>
      </Grid>

      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="custListponsive-dialog-title"
        sx={{ backdropFilter: "blur(0.5px)" }}
        PaperProps={{
          sx: {
            backgroundColor: tokens.colors.offWhite,
            border: `1px solid ${tokens.colors.connectedPurple}22`,
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(67, 37, 104, 0.18)",
            minWidth: { xs: "88vw", sm: "520px" },
            maxWidth: "620px",
            fontFamily: "Area Normal, Inter, sans-serif",
          },
        }}
      >
        <Box sx={{ backgroundColor: tokens.colors.offWhite }}>
          <Stack
            display="flex"
            direction="row"
            //  spacing={20}
            justifyContent="space-between"
            alignItems="center"
            sx={{
              px: 2.5,
              py: 1.75,
              borderBottom: `1px solid ${tokens.colors.connectedPurple}1A`,
              backgroundColor: tokens.colors.offWhite,
            }}
          >
            <DialogTitle
              sx={{
                p: 0,
                fontWeight: 700,
                fontSize: "20px",
                color: primaryColor,
                fontFamily: "Area Normal, Inter, sans-serif",
              }}
            >
              {dialogTitle}
            </DialogTitle>
            <DialogTitle
              sx={{
                p: 0,
                fontWeight: 400,
                fontSize: "21px",
                color: primaryColor,
              }}
            >
              <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
            </DialogTitle>
          </Stack>
        </Box>
        <DialogContent sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <TextField
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "999px",
                  backgroundColor: tokens.colors.offWhite,
                  fontFamily: "Area Normal, Inter, sans-serif",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${tokens.colors.connectedPurple}55`,
                },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${tokens.colors.connectedPurple}88`,
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: tokens.colors.connectedPurple,
                  borderWidth: "1px",
                },
                "& .MuiInputBase-input": {
                  py: "11px",
                  px: "14px",
                  fontSize: "15px",
                },
              }}
              variant="outlined"
              placeholder="Search Clients"
              value={searchTerm}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchTerm && (
                      <CloseIcon
                        onClick={() => {
                          setSearchTerm("");
                          setCustomerList(customerListRef); // reset full list
                        }}
                        sx={{
                          cursor: "pointer",
                          fontSize: "18px",
                          mr: 0.6,
                        }}
                      />
                    )}
                    <SearchIcon sx={{ color: tokens.colors.connectedPurple }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </DialogContent>

        <TableContainer
          sx={{
            maxHeight: 240,
            overflow: "auto",
            width: "100%",
            px: 2.5,
          }}
        >
          <Container sx={{ px: 0 }}>
            <Table size="small">
              <TableBody>
                {customerList && customerList.map((customer, index) => (
                  <TableRow
                    key={customer.customerId}
                    hover
                    role="checkbox"
                    selected={
                      selectedCustomerObj?.customerId === customer.customerId
                    }
                    sx={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedCustomerObj?.customerId === customer.customerId
                          ? `${tokens.colors.connectedPurple}12`
                          : "transparent",
                    }}
                    onClick={(event) => customerSelected(customer)}
                    tabIndex={-1}
                  >
                    <TableCell
                      onClick={() => customerSelected(customer)}
                      sx={{
                        borderBottom: "none",
                        textAlign: "left",
                        fontSize: "13px",
                        color: "#424242",
                        fontWeight: 500,
                        pl: 2,
                        py: 1.5,
                        opacity: 1,
                        fontFamily: "Area Normal, Inter, sans-serif",
                      }}
                    >
                      {customer.customerName.length > 45 ? (
                        <Tooltip title={customer.customerName} arrow>
                          <span>
                            {customer.customerName.substring(0, 45)}...
                          </span>
                        </Tooltip>
                      ) : (
                        customer.customerName
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderBottom: "none",
                        py: 1.5,
                        px: 1.5,
                        textAlign: "right",
                        color: "#666",
                        fontSize: "12px",
                        fontFamily: "Area Normal, Inter, sans-serif",
                      }}
                    >
                      {customer.customerId}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Container>
        </TableContainer>

        <Box sx={{ px: 2.5, pb: 2 }}>
          <DialogActions sx={{ p: 0, pt: 1.5, justifyContent: "flex-end", gap: 1 }}>
            <TrackNowButton variant="tertiary" onClick={handleCancelClose}>
              Cancel
            </TrackNowButton>
            <TrackNowButton
              variant="primary"
              onClick={handleChange}
              disabled={!selectedCustomerObj}
            >
              Select Client
            </TrackNowButton>
          </DialogActions>
        </Box>
      </Dialog>
    </Container>
  );
}

export default ClientLookup;
